import moment from "moment";
import * as React from "react";
import { FileWithPreview } from "react-dropzone";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import {
  Field,
  InjectedFormProps,
  formValueSelector,
  reduxForm,
} from "redux-form";
import { ConstColor } from "src/config/styles_const/styles_const";
import Assets from "src/presentation/assets/img/assets";
import styled from "styled-components";
import { frontEndConfig } from "../../../../../config/config";
import { projectConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import { Status } from "../../../../../domain/model/project";
import {
  createMonthArray,
  createYearsArray,
} from "../../../../../util/commonFuntion";
import {
  createAddressOptionDom,
  createNoRequiredOptionItem,
  createOptionsFromMap,
} from "../../../../../util/select_option_function";
import * as Validator from "../../../../../util/validation";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import StyledThumbnailDropZone from "../../../../common/atom/drop_zone/styled_thumbnail_drop_zone";
import ErrorText from "../../../../common/atom/text/error_text";
import DatepickerWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/datepicker_wrapper";
import MonthDaysWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/month_days_wrapper";
import YearWrapper from "../../../../common/atom/wrapper/datepicker_wrapper/year_wrapper";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupCheckboxConnectRf from "../../../../common/molecular/form_group/form_group_checkbox_connect_rf";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import FormGroupMultiSelectConnectRf from "../../../../common/molecular/form_group/form_group_multi_select_connect_rf";
import FormGroupSelectConnectRf from "../../../../common/molecular/form_group/form_group_select_connect_rf";
import FormGroupTextareaConnectRf from "../../../../common/molecular/form_group/form_group_textarea_connect_rf";
import { AppState } from "../../../../store/app_state";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IStateProps {
  initialValues:
    | {
        status: Status;
        thumbnailURLFileObject?: File;
      }
    | undefined;
  formValues: any;
}

export interface SelectCoverImage {
  httpUrl: string;
  gsUrl: string;
}

interface IProps extends IStateProps {
  onGenerateProjectInfo: () => void;
  onSelectCoverImage: (i: number) => void;
  generatedProjectInfo:
    | {
        name: string;
        description: string;
        background: string;
        preferentialExperience: string;
      }
    | undefined;
  selectedCoverImage: SelectCoverImage | undefined;
}

interface IState {
  imageError: string | null;
  showHelp: boolean;
}

export class ClientProjectMainCreateForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {
      imageError: null,
      showHelp: false,
    };
  }

  public componentWillUnmount(): void {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.props.formValues != null) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public componentDidUpdate(prevProps: IProps & InjectedFormProps<{}, IProps>) {
    if (this.props.generatedProjectInfo) {
      if (
        (prevProps.generatedProjectInfo != null
          ? prevProps.generatedProjectInfo!.name
          : "") !== this.props.generatedProjectInfo.name
      ) {
        this.props.change("name", this.props.generatedProjectInfo.name);
      }

      if (
        (prevProps.generatedProjectInfo != null
          ? prevProps.generatedProjectInfo!.description
          : "") !== this.props.generatedProjectInfo.description
      ) {
        this.props.change(
          "description",
          this.props.generatedProjectInfo.description
        );
      }

      if (
        (prevProps.generatedProjectInfo != null
          ? prevProps.generatedProjectInfo!.background
          : "") !== this.props.generatedProjectInfo.background
      ) {
        this.props.change(
          "background",
          this.props.generatedProjectInfo.background
        );
      }

      if (
        (prevProps.generatedProjectInfo != null
          ? prevProps.generatedProjectInfo!.preferentialExperience
          : "") !== this.props.generatedProjectInfo.preferentialExperience
      ) {
        this.props.change(
          "preferentialExperience",
          this.props.generatedProjectInfo.preferentialExperience
        );
      }
    }

    if (this.props.selectedCoverImage) {
      this.props.change("thumbnailURL", this.props.selectedCoverImage.gsUrl);
    }
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting } =
      this.props;

    let selectedCoverImageUrl: string | undefined;
    if (this.props.selectedCoverImage) {
      selectedCoverImageUrl = this.props.selectedCoverImage.httpUrl;
    }

    const updateThumbnailURL: string | null = this.props.formValues
      ? this.props.formValues.preview
      : selectedCoverImageUrl || null;

    let res: JSX.Element;

    // 編集ページ
    res = (
      <React.Fragment>
        <form name="clientProjectMainCreateForm" onSubmit={handleSubmit}>
          <StyledThumbnailDropZone
            name={"clientProjectMainCreateForm-dropzone"}
            handleOnDrop={this.handleOnDrop}
            updateThumbnailURL={updateThumbnailURL}
            thumbnailURL={""}
          />
          <Field
            type="hidden"
            name="thumbnailURL"
            component={FormGroupInputConnectRf}
            validate={[]}
            require={false}
          />

          <TemplateTitle>テンプレートからカバー画像を選ぶ</TemplateTitle>
          <TemplateList>
            {Array.from({ length: 10 }, (_, i) => i + 1).map((i) => {
              const coverName = `cover${i}`;
              const coverImage = (Assets as any)[coverName];
              return (
                <TemplateImage
                  key={i}
                  src={coverImage}
                  onClick={() => {
                    this.props.onSelectCoverImage(i);
                  }}
                ></TemplateImage>
              );
            })}
          </TemplateList>

          <FormFieldWrapper>
            <OpenAILink>
              <OpenAILinkText
                onClick={() => {
                  this.props.onGenerateProjectInfo();
                }}
              >
                生成AIで案件情報の下書きを行う
              </OpenAILinkText>
              <OpenAILinkIconContainer>
                <OpenAILinkIcon
                  src={Assets.help}
                  onClick={() => {
                    this.setState({ showHelp: true });
                  }}
                />
                <OpenAITooltip>
                  生成AIを用いて、あなたが入力する案件タイトルを元に案件情報の下書きを作成する機能です。
                  <br />
                  下書きを行うボタンを押すと、ポップアップが表示され、下書きが作成されます。
                  <br />
                  その情報を必要に応じて書き換えて保存することができます。
                </OpenAITooltip>
              </OpenAILinkIconContainer>
            </OpenAILink>
            <Field
              label={projectConfig.nameLabel}
              placeholder="医療系SaaSプロダクト設計アドバイザー募集"
              name="name"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.projectName, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.descriptionLabel}
              placeholder="・医療系SaaSプロダクトの設計・開発におけるアドバイス提供
・プロダクトの仕様策定および改善提案
・ユーザーインターフェースおよびユーザーエクスペリエンスの最適化
・技術的な問題解決および技術選定の支援
・開発チームとの定期的なミーティングおよびフィードバックの提供"
              name="description"
              rows={5}
              component={FormGroupTextareaConnectRf}
              type="text"
              validate={[Validator.projectDescription, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.backgroundLabel}
              placeholder="弊社は医療系SaaSソリューションの提供を目指しており、新規プロダクトの設計・開発を進めています。この度、より専門性の高い知見を取り入れ、プロダクトの品質を向上させるため、経験豊富なプロダクト設計アドバイザーを募集することとなりました。医療業界の特有のニーズを理解し、最適なソリューションを提案できる方を求めています。"
              name="background"
              component={FormGroupTextareaConnectRf}
              rows={5}
              type="text"
              validate={[Validator.projectBackground, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.preferentialExperienceLabel}
              placeholder="・医療系SaaSプロダクトの設計・開発経験（5年以上）
・UX/UIデザインに関する知識と実務経験
・ソフトウェア開発における技術選定および問題解決の経験
・開発チームとの協働経験およびリーダーシップスキル"
              name="preferentialExperience"
              component={FormGroupTextareaConnectRf}
              rows={5}
              type="text"
              validate={[Validator.projectPreferentialExperience]}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.paymentRangeLabel}
              name="paymentRange"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.paymentRangeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.workingHourRangeLabel}
              name="workingHourRange"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.workingHourRangeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.placeLabel}
              name="place"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.placeList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.occupationsLabel}
              name="occupations"
              component={FormGroupMultiSelectConnectRf}
              type="select-multiple"
              isMulti={true}
              options={createOptionsFromMap(projectConfig.occupationList)}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <DatepickerWrapper>
              <YearWrapper>
                <Field
                  label={`${projectConfig.operatingDateLabel}：年`}
                  name={`operatingDate.year`}
                  component={FormGroupSelectConnectRf}
                  type="text"
                >
                  {createAddressOptionDom(
                    createYearsArray(10, Number(moment().year().toString()) + 4)
                  )}
                </Field>
              </YearWrapper>
              <MonthDaysWrapper>
                <Field
                  label={`${projectConfig.operatingDateLabel}：月`}
                  name={`operatingDate.month`}
                  component={FormGroupSelectConnectRf}
                  type="text"
                >
                  {createAddressOptionDom(createMonthArray())}
                </Field>
              </MonthDaysWrapper>
            </DatepickerWrapper>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={projectConfig.workingDurationLabel}
              name="workingDuration"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              {createNoRequiredOptionItem(projectConfig.workingDurationList)}
            </Field>
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label="企業情報を非公開にする"
              name="isHideCompany"
              component={FormGroupCheckboxConnectRf}
            />
          </FormFieldWrapper>

          <FormFieldWrapper>
            <Field
              label={projectConfig.statusLabel}
              name="status"
              component={FormGroupSelectConnectRf}
              type="text"
            >
              <option value={Status.Status_Open}>
                {projectConfig.statusList[Status.Status_Open]}
              </option>
              <option value={Status.Status_Draft}>
                {projectConfig.statusList[Status.Status_Draft]}
              </option>
              <option value={Status.Status_OnlyScout}>
                {projectConfig.statusList[Status.Status_OnlyScout]}
              </option>
            </Field>
          </FormFieldWrapper>

          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <BtnCorporateLarge
              name="clientProjectMainCreateForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting || invalid}
            >
              保存
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );

    return res;
  }

  private handleOnDrop = (
    acceptedFiles: FileWithPreview[],
    rejectedFiles: FileWithPreview[]
  ): void => {
    try {
      this.setState({ imageError: null });

      if (rejectedFiles.length > 1) {
        throw new Error("複数のファイルが選択されました");
      } else if (
        rejectedFiles.length > 0 &&
        rejectedFiles[0].size > uploadFileMaxSize
      ) {
        throw new Error("ファイルサイズオーバ");
      } else {
        this.props.change("thumbnailURLFileObject", acceptedFiles[0]);
      }
    } catch (error) {
      this.setState({ imageError: error.message });
    }
  };
}

const selector = formValueSelector("clientProjectMainCreateForm");

const mapStateToProps = (state: AppState, initialProps: any) => {
  return {
    formValues: selector(state, "thumbnailURLFileObject"),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm<{}, IProps>({
  form: "clientProjectMainCreateForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ClientProjectMainCreateForm));

const OpenAILinkText = styled.div`
  color: ${ConstColor.Corporate};
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
`;

const OpenAILinkIcon = styled.img`
  display: block;
  margin-left: 10px;
  cursor: pointer;
`;

const OpenAITooltip = styled.div`
  position: absolute;
  bottom: -80px; // 要素の高さに応じて調整する
  right: 0px;
  background-color: black;
  color: white;
  padding: 5px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 14px;
`;

const OpenAILink = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`;

const OpenAILinkIconContainer = styled.div`
  & > ${OpenAITooltip} {
    display: none;
  }

  // ホバー時にツールチップを表示する
  &:hover > ${OpenAITooltip} {
    display: block;
  }
`;

const TemplateTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 20px;
`;

const TemplateList = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 30px;
`;

const TemplateImage = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 4px;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/project/create/client_project_main_create_form.tsx